import React from "react";

import Loading from "../../components/Loading/index.js";
import PassCodeContainer from "../../components/PassCodeContainer/index.js";

function PassCode({
	loading,
	initialLoading,
	document,
	onSubmitPassCode
}) {
	if (!document || initialLoading) {
		return <Loading />
	}

	return <PassCodeContainer loading={loading} onSubmit={onSubmitPassCode} />;
}

export default PassCode;
